import { Reducer } from "redux";
import {
	TagActions,
	TagActionTypes
} from "@/Actions/Tags/TagActions";
import {
	Tag,
	TagEntityBucket,
	TagEntityType,
	TagsState
} from "@/Contracts/Tags";

export const initialState: TagsState = {
	byEntityType: {}
};

const emptyBucket: TagEntityBucket = {
	loading: false,
	tags: []
};

const mergeTags = (existing: Tag[], incoming: Tag[]): Tag[] => {
	const byId = new Map<string, Tag>();
	existing.forEach(tag => byId.set(tag.id, tag));
	incoming.forEach(tag => byId.set(tag.id, tag));
	return Array.from(byId.values());
};

const updateBucket = (
	state: TagsState,
	entityType: TagEntityType,
	updater: (bucket: TagEntityBucket) => TagEntityBucket
): TagsState => {
	const current = state.byEntityType[entityType] ?? emptyBucket;
	return {
		...state,
		byEntityType: {
			...state.byEntityType,
			[entityType]: updater(current)
		}
	};
};

export const TagReducer: Reducer<TagsState, TagActions> = (
	state: TagsState = initialState,
	action: TagActions
): TagsState => {
	switch (action.type) {
		case TagActionTypes.FETCH_TAGS_REQUESTED: {
			return updateBucket(state, action.entityType, bucket => ({
				...bucket,
				loading: true,
				error: undefined
			}));
		}
		case TagActionTypes.FETCH_TAGS_SUCCESSFUL: {
			return updateBucket(state, action.entityType, () => ({
				loading: false,
				loadedAtMs: Date.now(),
				tags: action.tags
			}));
		}
		case TagActionTypes.FETCH_TAGS_FAILED: {
			return updateBucket(state, action.entityType, bucket => ({
				...bucket,
				loading: false,
				error: action.error
			}));
		}
		case TagActionTypes.BULK_UPSERT_TAGS_SUCCESSFUL: {
			return updateBucket(state, action.entityType, bucket => ({
				...bucket,
				tags: mergeTags(bucket.tags, action.tags)
			}));
		}
		default: {
			return state;
		}
	}
};

export default TagReducer;
